// Code copied form dropdown component
//Component use:
//<ep-selector [values]="dropdownValues" [(value)]="value"></selector>
//<ep-selector codeSet="LineCode" [values] = "{Code:'ALL',Code_Desc: "All Lines"} [(value)] = "value" > </selector>
//<ep-selector codeSet="LineCode" [(value)] = "model.Line_Code"  (valueChange) = "valueChangeLineCode($event)" > </selector>


//TODO  Change DropdownValue type to CodeValue  (more generic)

//TODO   Implement in a more efficient way.   Rather than relying up bootstrap "hidden" classes  
// calculate min button with based on parent width and use ngIf.

// Return simple value (CODE) or complex value (CODE,DESC)?   Later may be better if description is needed outside of control.

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CodeSetDataService } from '@Core/services/proprietary/codeset-data.service';
import { DropdownValue } from './dropdown.component';

@Component({
    standalone: false,
    selector: 'ep-selector',
    template: `
    <div class="unity-form-group select">
      <label for="{{ name }}" *ngIf="label">{{ label }}</label>
      <div [class]="'unity-form-row ' + dropdownClass">
        <select [disabled]="controlDisabled" [(ngModel)]="value" (ngModelChange)="onChange($event)">
          <option *ngIf="nullValue" [value]="nullValue.Code" [ngbTooltip]="nullValue.Tooltip || nullValue.Code_Desc">
            &lt;{{ nullValue.Code_Desc }}&gt;
          </option>
          <option *ngFor="let v of values" [value]="v.Code" [ngbTooltip]="v.Tooltip">{{ v.Code_Desc }}</option>
        </select>
        <svg class="unity-icon unity-icon-chevron-down">
          <use xlink:href="#unity-icon-chevron-down"></use>
        </svg>
      </div>
      <unity-button-segmented [class]="buttonGroupClass" [disabled]="controlDisabled">
        <button
          *ngFor="let v of values"
          [class.on]="value == v.Code"
          type="button"
          data-toggle="button"
          [ngbTooltip]="v.Tooltip || v.Code_Desc"
          (click)="onChange(v.Code)"
        >
          <i *ngIf="v.ShowIcon && !v.Icon.includes('unity-icon')" [class]="'fa ' + v.Icon"></i>
          <svg *ngIf="v.ShowIcon && v.Icon.includes('unity-icon')" [class]="'unity-icon ' + v.Icon">
            <use attr.xlink:href="#{{ v.Icon }}"></use>
          </svg>
          {{ v.Code_Desc }}
        </button>
        <button
          *ngIf="nullValue"
          [class.on]="value == null"
          class="btn btn-secondary"
          type="button"
          [ngbTooltip]="nullValue.Tooltip || nullValue.Code_Desc"
          (click)="onChange(null)"
        >
          <i *ngIf="nullValue.ShowIcon && !nullValue.Icon.includes('unity-icon')" [class]="'fa ' + nullValue.Icon"></i>
          <svg
            *ngIf="nullValue.ShowIcon && nullValue.Icon.includes('unity-icon')"
            [class]="'unity-icon ' + nullValue.Icon"
          >
            <use attr.xlink:href="#{{ nullValue.Icon }}"></use>
          </svg>
          {{ nullValue.Code_Desc }}
        </button>
      </unity-button-segmented>
    </div>
  `,
    providers: []
})
export class SelectorComponent {
    @Input()
    values: DropdownValue[] = [];

    @Input()
    nullValue: DropdownValue = null;

    @Input()
    value: string = null;

    @Input()
    codeSet: string = 'NONE';

    @Input('disabled')
    controlDisabled: boolean = false; //is this the right way?

    @Input()
    set label(value: string) {
        this._label = value;
        // CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
        // this.setRootID();
        // END CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    }

    @Input()
    set name(value: string) {
        this._name = value;
        // CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
        // this.setRootID();
        // END CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    }

    get label(): string {
        return this._label;
    }

    get name(): string {
        return this._name;
    }

    _minButtonModeSize: string;
    get minButtonModeSize(): string {
        return this._minButtonModeSize;
    }
    @Input()
    set minButtonModeSize(value: string) {
        this._minButtonModeSize = value;
        if (value) {
            switch (value.toLowerCase()) {
                case 'xs':
                    this.buttonGroupClass = 'd-block';
                    this.dropdownClass = 'd-none';
                    break;
                case 'sm':
                    this.buttonGroupClass = 'd-none d-sm-block';
                    this.dropdownClass = 'd-block d-sm-none';
                    break;
                case 'md':
                    this.buttonGroupClass = 'd-none d-md-block';
                    this.dropdownClass = 'd-sm-block d-md-none';
                    break;
                case 'lg':
                    this.buttonGroupClass = 'd-none d-lg-block';
                    this.dropdownClass = 'd-md-block d-lg-none';
                    break;
                case 'xl':
                    this.buttonGroupClass = 'd-none d-xl-block';
                    this.dropdownClass = 'd-lg-block d-xl-none';
                    break;
                case 'nb' /* no buttons */:
                    this.buttonGroupClass = 'd-none';
                    this.dropdownClass = 'd-block';
                    break;
            }
        }
    }

    @Output()
    // is this the proper name? should in match the event on the control????   select, change, onchanged, valuechanged?????
    valueChange: EventEmitter<any>;
    private _name: string = null;
    private _label: string = null;
    // CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    // private _rootID: string = 'Unknown';
    // END CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    errorMessage: string;

    dropdownClass: string = 'd-none d-sm-none d-md-none d-lg-none d-xl-none';
    buttonGroupClass: string = '';

    constructor(private codeSetDataService: CodeSetDataService) {
        this.valueChange = new EventEmitter();
    }

    ngOnInit() {
        if (this.codeSet.toUpperCase() != 'NONE') {
            this.getCodes(this.codeSet);
        }
        this.getUnityDropdownClass();
    }

    //   CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe
    //   REMOVED ID SETTING CODE ADDED FOR ASCENTIAL TEST
    //   LATER ON WE SHOULD CONSIDER A STORY TO REMOVE COMMENTED OUT CODE IF WE DON'T HAVE NEED FOR THE ID SETTING.
    //
    //   setRootID() {
    //     if (this._name) {
    //       this._rootID = this._name.replace(/[^\w]|_/g, ''); //all numbers/letters  (w is all numbers and letters and underscores )
    //     } else if (this._label) {
    //       this._rootID = this._label.replace(/[^\w]|_/g, ''); //all numbers/letters  (w is all numbers and letters and underscores )
    //     } else {
    //       this._rootID = 'Unknown';
    //     }
    //   }
    //
    //   buildOptionIDAttribute(option: any) {
    //     if (option != null) {
    //       return (
    //         'Option' +
    //         this._rootID +
    //         option
    //           .toString()
    //           .replace(/[^\w]|_/g, '')
    //           .toUpperCase()
    //       ); //all numbers/letters  (w is all numbers and letters and underscores )
    //     } else {
    //       return 'Option' + this._rootID + 'Null';
    //     }
    //   }
    //
    //
    //   buildSelectorIDAttribute() {
    //     return 'Select' + this._rootID;
    //   }
    //
    //   END CLEAN-UP! 3a2dbc1d-962e-4a72-bb9e-bb072dc92dbe

    getCodes(codeSet: string) {
        this.codeSetDataService.get(codeSet).subscribe(
            (values) => {
                this.values = values;
            },
            (error) => (this.errorMessage = <any>error)
        );
    }

    get diagnostic() {
        return JSON.stringify(this.values);
    }

    //use "on" prefix on events?
    onChange(value: any) {
        //console.log("emitting valueChange(" + value + ")");
        if (value == 'null') {
            value = null;
            this.value = null;
        }
        this.valueChange.emit(value);
    }

    clear() {
        this.value = '';
        this.valueChange.emit('');
    }

    getUnityDropdownClass() {
        if (this._minButtonModeSize) {
            switch (this._minButtonModeSize.toLowerCase()) {
                case 'xs':
                    this.dropdownClass = 'd-none';
                    break;
                case 'sm':
                    this.dropdownClass = 'd-flex d-sm-none';
                    break;
                case 'md':
                    this.dropdownClass = 'd-sm-flex d-md-none';
                    break;
                case 'lg':
                    this.dropdownClass = 'd-md-flex d-lg-none';
                    break;
                case 'xl':
                    this.dropdownClass = 'd-lg-flex d-xl-none';
                    break;
                case 'nb' /* no buttons */:
                    this.dropdownClass = 'd-flex';
                    break;
            }
        } else {
            return '';
        }
    }
}
